export default __webpack_public_path__ + "static/media/slide2.d58e7971.webp";